module.exports = __webpack_public_path__ + "static/media/InformedConsent.5364997e.pdf";